import { addLibs } from './base'
import './lazy-base'
import * as oidc from './oidc'
import * as mui from './material-ui'
import * as reactstrap from 'reactstrap'
import * as TokenManager from '@sparky/token-manager'
import versions from './versions'

if (TokenManager.TokenManager && !('default' in TokenManager)) {
  Object.defineProperties(TokenManager, { default: { value: (TokenManager as any).TokenManager } })
}

export default addLibs({
  ...oidc,
  ...mui,
  reactstrap,
  TokenManager,
  versions,
})
